import { getBillingIntervalInMonths } from '@vy/services';
import { BILLING_INTERVALS, type UserInputBillingInterval } from '@vy/types';
import { values } from '@vy/utils';
import { getMonthIntervalLabel } from './month-interval-labels';

export const BILLING_INTERVAL_OPTIONS = values(BILLING_INTERVALS);

export function getBillingIntervalLabel(option: UserInputBillingInterval): string {
  return getMonthIntervalLabel(getBillingIntervalInMonths(option));
}
